(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/play/iwg/utils.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/play/iwg/utils.js');
"use strict";


const onMaximize = () => {
  document.body.classList.add('e-instant-body-fullscreen');
  const el = document.body;
  if (el.requestFullscreen) {
    el.requestFullscreen();
  } else if (el.mozRequestFullScreen) {
    el.mozRequestFullScreen();
  } else if (el.webkitRequestFullscreen) {
    el.webkitRequestFullscreen();
  } else if (el.msRequestFullscreen) {
    el.msRequestFullscreen();
  } else {
    svs.components.dialog.api.add(new svs.components.dialog.Confirm({
      icon: 'time-limit',
      branding: svs.components.dialog.branding.TUR,
      type: svs.components.dialog.type.ERROR,
      title: 'Nu blev det fel!',
      message: [{
        type: svs.components.dialog.message.TEXT,
        text: 'Din webbläsare stödjer inte helskärm.'
      }],
      actions: [{
        title: 'OK'
      }]
    }));
    return false;
  }
};
const onMinimize = () => {
  document.body.classList.remove('e-instant-body-fullscreen');
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
};
const updateAccountBalance = e => {
  var _svs$eInstant$data;
  if (((_svs$eInstant$data = svs.eInstant.data) === null || _svs$eInstant$data === void 0 || (_svs$eInstant$data = _svs$eInstant$data.iwgGame) === null || _svs$eInstant$data === void 0 ? void 0 : _svs$eInstant$data.gameUrl.indexOf(e.origin)) >= 0 && e.data && e.data === 'GameFinished') {
    svs.components.account_balance.get(true);
  }
};
setGlobal('svs.eInstant.play.iwg.utils', {
  onMaximize,
  onMinimize,
  updateAccountBalance
});

 })(window);